import { COLORS } from "constants/colors";

export const cl = {
  root: {
    width: "100vw",
    backgroundColor: COLORS.backgroundLight,
    p: { xs: "48px 16px", sm: "60px 80px" },
    alignItems: "center",
    minHeight: "100vh",
  },
  cardsContainer: {
    mb: { xs: 0, sm: 6 },
    width: "100%",
  },
  card: (isMobile, isActive, hoverBg, sharedBg) => ({
    cursor: "pointer",
    p: isMobile ? 2.5 : 3,
    width: isMobile ? "100%" : 220,
    boxSizing: "border-box",
    minHeight: isMobile ? 120 : 160,
    display: "flex",
    flexDirection: { xs: "row", sm: "column" },
    alignItems: { xs: "center", sm: "flex-start" },
    borderRadius: 3,
    backgroundColor: isActive ? hoverBg : sharedBg,
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: COLORS.white,
    },
    gap: isMobile ? 2 : 0,
    WebkitTapHighlightColor: "transparent",
    WebkitTouchCallout: "none",
    WebkitUserSelect: "none",
    userSelect: "none",
    "&:active": {
      backgroundColor: isActive ? hoverBg : sharedBg,
    },
  }),
  iconContainer: (isMobile, color) => ({
    width: isMobile ? 36 : 44,
    height: isMobile ? 36 : 44,
    borderRadius: "50%",
    backgroundColor: color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: isMobile ? 0 : 1.5,
    flexShrink: 0,
  }),
  icon: (isMobile) => ({
    color: "#fff",
    fontSize: isMobile ? 20 : 24,
  }),
  cardContent: {
    flex: 1,
  },
  cardTitle: () => ({
    mb: 0.5,
    color: "text.primary",
  }),
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    overflow: "hidden",
    backgroundColor: "#fff",
    mx: "auto",
    width: "fit-content",
    maxWidth: "100%",
    py: 2,
  },
  image: (isMobile) => ({
    maxWidth: "100%",
    height: "auto",
    width: isMobile ? "100%" : "1000px",
    userSelect: "none",
  }),
};
